import * as React from 'react'
import { bind } from 'classnames/bind'
import * as styles from '@procore/core-css/src/layouts/_badge.scss'

import addSubcomponents from '../utils/addSubcomponents'
import { Props, DivAttributes } from '../utils/types'

const cx = bind(styles)

interface BadgeProps extends Props {}

interface BadgeLabelProps extends Props {}

const Badge = React.forwardRef<HTMLDivElement, DivAttributes & BadgeProps>(
  (props, ref) => (
    <div ref={ref} {...props} className={cx('core-badge', props.className)}>
      {props.children}
    </div>
  )
)

const Label = React.forwardRef<HTMLDivElement, DivAttributes & BadgeLabelProps>(
  (props, ref) => (
    <div
      ref={ref}
      {...props}
      className={cx('core-badge__label', props.className)}
    >
      {props.children}
    </div>
  )
)

Badge.displayName = 'Badge'

Label.displayName = 'Badge.Label'

export default addSubcomponents(
  {
    Label,
  },
  Badge
)
